export enum ChargeLevel {
  Misdemeanor = 1,
  Felony = 2,
  Traffic = 4,
  CriminalTraffic = 5,
  PettyMisdemeanors = 7,
  OrdinanceViolation = 9,
  Infraction = 10,
  Other = 11,
  Summary = 12,
  MinorMisdemeanor = 13
}



// WEBPACK FOOTER //
// ./src/models/chargeLevels.ts